import firebase from '../../firebase';

export default async function searchRides(params) {
    const result = await firebase.functions().httpsCallable('search-rides')(params);
    if (result && result.data) {
        return result.data;
    }
    return {};
}
